






















































import {Vue, Component, Watch} from 'vue-property-decorator'
import { mixins } from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import {Odsustvo, VrstaOdsustva} from "@/services/BackendProxies";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class UnosOdsustva extends mixins(ComponentBaseMixin) {
    godinaSelected = new Date().getFullYear();
    godineOptions = [new Date().getFullYear(), new Date().getFullYear() - 1];

    odsustvo = Odsustvo.fromJS({});
    odsustva = [];
    columns = [];
    tableOptions = {
        onClickRow: row => this.onClickRow(row)
    };
    vrsteOdsustva = [];
    async created() {
        this.odsustva = await this.loadData(() => dataProxy.vratiOdsustva(this.godinaSelected))();
        this.columns = [
            {field: 'osoba', title: this.$i18n.t('osoba'), width: 180},
            {field: 'vrstaOdsustva', title: this.$i18n.t('vrstaOdsustva'), width: 200},
            {field: 'datumOd', title: this.$i18n.t('od'), width: 100, formatter: formatDate},
            {field: 'datumDo', title: this.$i18n.t('do'), width: 100, formatter: formatDate}
        ];
        const vrste = this.vrsteOdsustva = await this.loadData(() => dataProxy.vratiVrsteOdsustva())();
        vrste.unshift(VrstaOdsustva.fromJS({id: '', naziv: '...'}));
        this.vrsteOdsustva = vrste.map(v => ({id: v.id, text: v.naziv}));

        this.$nextTick(() => (<any>this.$refs.observer).validate());
    }

    novoOdsustvo() {
        this.odsustvo = new Odsustvo();
    }

    async sacuvajOdsustvo() {
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            this.odsustvo = await this.saveData(() => dataProxy.sacuvajOdsustvo(this.odsustvo))();
            this.odsustva = await this.loadData(() => dataProxy.vratiOdsustva(this.godinaSelected))();
        }
    }

    async obrisiOdsustvo() {
        const da = await this.confirmationNeeded('da li zelite da obrisete odsustvo');
        if (da) {
            this.odsustva = await this.deleteData(() => dataProxy.obrisiOdsustvo(this.odsustvo.id))();
            this.novoOdsustvo();
        }
    }

    onClickRow(row) {
        this.odsustvo = row;
    }

    @Watch('godinaSelected') async onGodinaChanged(godina) {
        this.odsustva = await this.loadData(() => dataProxy.vratiOdsustva(godina))();
    }
}
